/** Preserve the existing ten-minute early-entry window; authorization stays server-side. */
export const isDmpMeetingJoinTime = (start: string | undefined, now = Date.now()): boolean => {
  if (typeof start !== 'string' || !start) return false;
  const startsAt = new Date(start.replace(' ', 'T')).getTime();
  return Number.isFinite(startsAt) && startsAt - now < 10 * 60 * 1000;
};

export const hasDmpMeeting = (meeting: { meetingID?: string } | null | undefined): meeting is { meetingID: string } =>
  typeof meeting?.meetingID === 'string' && Boolean(meeting.meetingID.trim());

export const dmpMeetingFailure = (error: unknown, english: boolean): string => {
  const response = (error as { response?: { status?: number; data?: { message?: string; data?: Record<string, string[]>; errors?: Record<string, string[]> } } })?.response;
  const body = response?.data;
  const codes = [body?.message, ...Object.values(body?.data || {}).flat(), ...Object.values(body?.errors || {}).flat()].join(' ');
  if (/reconciliation_required/.test(codes)) return english
    ? 'Meeting usage is awaiting confirmation. Please contact eBRAM if the meeting remains unavailable.'
    : '會議使用狀態正在確認中；若持續無法加入，請聯絡 eBRAM。';
  if (/meeting_duration_reached/.test(codes)) return english
    ? 'This meeting has reached its available duration. The host can review the remaining allowance in their subscription.'
    : '此會議已達可用時長上限，主持人可至訂閱與方案查看剩餘額度。';
  if (/meeting_minute_balance_required/.test(codes)) return english
    ? 'There are not enough video conferencing minutes available. The host can review the allowance in their subscription.'
    : '可用視訊會議分鐘數不足，主持人可至訂閱與方案查看額度。';
  if (/meeting_not_started|meeting_time_invalid/.test(codes)) return english
    ? 'The meeting is not open yet or its schedule is invalid. Please check the scheduled start time.'
    : '尚未到可加入時間，或會議時間資料無效，請確認開始時間。';
  if (/meeting_already_active|meeting_already_bound/.test(codes)) return english
    ? 'A meeting connection already exists. Reload the event to view the original meeting instead of creating another one.'
    : '會議連線已存在，請重新載入活動查看原會議，勿重複建立。';
  if (/runtime_adapter_pending|runtime_unavailable|meeting_create_unavailable|meeting_instance_unavailable|meeting_instance_conflict/.test(codes)) return english
    ? 'Video conferencing is temporarily unavailable. Please try again later or contact eBRAM.'
    : '目前暫時無法使用視訊會議，請稍後再試或聯絡 eBRAM。';
  if (/quota_exhausted|positive_balance_required|insufficient_balance|limit reached/.test(codes)) return english
    ? 'Your video conferencing allowance is used up. View your subscription for available minutes.'
    : '視訊會議額度已用完，請至訂閱與方案查看可用分鐘數。';
  if (response?.status === 403) return english
    ? 'You do not have permission to create or join this meeting.'
    : '你沒有建立或加入此會議的權限。';
  if (response?.status === 404) return english
    ? 'No valid meeting was found. Please contact the host.'
    : '找不到有效會議，請聯絡主持人確認。';
  return english
    ? 'The meeting could not be created or opened. Please retry; the event has not been saved if meeting creation failed.'
    : '無法建立或開啟會議，請重試；若會議建立失敗，活動不會儲存。';
};
